import { CallToActionButton } from '@/components/shared/CallToActionButton';
import { DotBlockEditor } from '@/components/shared/decodeTextBlock';
import customRenderers from '@/components/block-editor';
import safeJsonParse from '@/app/utils/safeJSONParse';

function TerminalWindow({ fileName, snippet }) {
    if (!snippet) return null;
    return (
        <div className="mx-auto mt-14 w-full max-w-3xl overflow-hidden rounded-2xl bg-white shadow-[0_30px_60px_-30px_rgba(12,18,49,0.25)]">
            <div className="flex items-center gap-3 border-b border-slate-100 bg-slate-50 px-4 py-3">
                <div className="flex gap-1.5">
                    <span className="size-3 rounded-full bg-slate-300" />
                    <span className="size-3 rounded-full bg-slate-300" />
                    <span className="size-3 rounded-full bg-slate-300" />
                </div>
                {fileName && (
                    <span className="font-mono text-xs text-slate-500">
                        &gt;_ {fileName}
                    </span>
                )}
            </div>
            <pre className="overflow-x-auto whitespace-pre p-6 font-mono text-sm leading-relaxed text-slate-800">
                <code>{snippet}</code>
            </pre>
        </div>
    );
}

function StepCard({ index, title, description, description_raw }) {
    const parsedDescription = description ?? safeJsonParse(description_raw);
    return (
        <div className="relative flex flex-col rounded-2xl bg-white p-6 shadow-[0_20px_50px_-24px_rgba(12,18,49,0.18)] sm:p-8">
            <span
                aria-hidden
                className="absolute right-5 top-3 font-serif text-2xl italic text-fuschia-500 sm:text-3xl">
                {index}
            </span>
            {title && (
                <h3 className="mt-6 text-base font-bold leading-snug text-slate-900">{title}</h3>
            )}
            {parsedDescription && (
                <div className="mt-3 text-sm leading-relaxed text-slate-600">
                    <DotBlockEditor customRenderers={customRenderers} blocks={parsedDescription} />
                </div>
            )}
        </div>
    );
}

function NumberedSteps({ sectionHeading, steps, codeSnippet, fileName, callToAction }) {
    const stepList = Array.isArray(steps) ? steps : [];
    const [button] = Array.isArray(callToAction) ? callToAction : [];

    return (
        <section
            data-component="numbered-steps"
            className="container flex flex-col items-center row-default-p">
            {sectionHeading && (
                <h2 className="text-3xl font-bold leading-tight text-slate-900 sm:text-4xl lg:text-5xl">
                    {sectionHeading}
                </h2>
            )}

            {stepList.length > 0 && (
                <div className="mt-12 grid w-full grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                    {stepList.map((step, i) => (
                        <StepCard
                            key={step?.identifier ?? i}
                            index={i + 1}
                            title={step?.title}
                            description={step?.description}
                            description_raw={step?.description_raw}
                        />
                    ))}
                </div>
            )}

            <TerminalWindow fileName={fileName} snippet={codeSnippet} />

            {button && button.urlName && button.url && (
                <div className="mt-10">
                    <CallToActionButton {...button}>{button.urlName}</CallToActionButton>
                </div>
            )}
        </section>
    );
}

export default NumberedSteps;
